import React from "react";
import * as S from "./styles";
import { UserInfo } from "../../types/user";
import {
  ADMIN_PAYMENT_URL,
  SCHOOL_URL,
  SCHOOL_SIGNUP_URL,
} from "../../constants/urls";

const FAQ_URL =
  "https://goofy-may-2ac.notion.site/322d45253157809da7aad7810a4418ad";

interface NavProps {
  userInfo: UserInfo | null;
  samName: string;
  toggleMenu: () => void;
}

const Nav: React.FC<NavProps> = ({ userInfo, samName, toggleMenu }) => {
  if (window.location.pathname === "/pricing") {
    return null;
  }
  return (
    <S.NavContainer>
      <S.NavList>
        <S.LogoLink to="/">
          <img
            src="/images/logo_bogun_2x.png"
            alt="logo"
            width={100}
            height={40}
          />
        </S.LogoLink>
        <S.NavItem>
          <S.NavLink to="/about">About Us</S.NavLink>
        </S.NavItem>
        <S.PrivacyLink
          onClick={() => {
            window.open(
              FAQ_URL,
              "_blank",
              "noopener,noreferrer"
            );
          }}
        >
          개인정보보호 서약양식
        </S.PrivacyLink>
      </S.NavList>
      <S.NavList>
        <S.ButtonItem>
          <S.AdminLink
            onClick={() => {
              window.open(ADMIN_PAYMENT_URL, "_self");
            }}
          >
            행정실 결제
          </S.AdminLink>
          {userInfo ? (
            <span>{`${samName} 선생님 반갑습니다. 😀`}</span>
          ) : (
            <S.UserButton
              onClick={() =>
                window.open(SCHOOL_URL, "_self")
              }
            >
              로그인
            </S.UserButton>
          )}
          {userInfo ? (
            <S.UserButton
              onClick={() =>
                window.open(SCHOOL_URL, "_self")
              }
            >
              보건일지 <span style={{ marginLeft: "5px" }}>➡️</span>
            </S.UserButton>
          ) : (
            <S.UserButton
              onClick={() =>
                window.open(SCHOOL_SIGNUP_URL, "_self")
              }
            >
              회원가입
            </S.UserButton>
          )}
        </S.ButtonItem>
      </S.NavList>
      <S.HamburgerMenuButton onClick={toggleMenu}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <g clipPath="url(#clip0_13114_11483)">
            <path
              d="M3.75 12H20.25"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.75 6H20.25"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.75 18H20.25"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13114_11483">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </S.HamburgerMenuButton>
    </S.NavContainer>
  );
};

export default Nav;
